import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { EncodingUtils } from '../encoding-utils';
import { copyObj } from '../../components/utils/utils';

@Injectable({
  providedIn: 'root',
})
export class MultipartHttpRequestService {
  constructor(private httpClient: HttpClient) {}

  sendMultipartHttpRequest<T>(url: string, method: string, formData: any): Observable<T> {
    let file: File;
    let fieldName: string;
    let data: any;

    Object.keys(formData).forEach((key) => {
      let isAset: boolean = false;

      if (formData[key] instanceof Set) {
        isAset = true;
        fieldName = key;
        const files: Set<File> = formData[key];
        if (files.size > 0) {
          files.forEach((f) => {
            file = f;
          });
        }
      }
    });
    data = copyObj(formData); // ctrls.getRawValue();
    if (file !== undefined) {
      data[fieldName] = file.name;

      const formData: FormData = new FormData();

      formData.append(fieldName, file, file.name);
      formData.append('data', JSON.stringify(EncodingUtils.encodeRequest(data)));
      let headers = new HttpHeaders();
      // we add content type so encoding-interceptor can identify and not encode, we also delete header
      headers = headers.append('Content-Type', 'multipart/form-data');
      return this.httpClient.post<T>(url, formData, { headers });
    }
    throwError(() => new Error('File is empty'));
  }
}
